module.exports = __webpack_public_path__ + "6f1a3853496ed7b3feb72d3142ffb714.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-27.png
// module id = 1744
// module chunks = 0